<template>
  <div :class="$style.base">
    <ThanksPage 
      v-if="formSubmitted" 
      v-test="'thanks-page'"
    />
    <ErrorPage 
      v-else-if="formNotFound" 
      v-test="'error-page'"
    />
    <FormPage 
      v-else-if="formTemplate"
      v-test="'form-page'"
    />
    <BaseSpinner v-else />
  </div>
</template>

<script>
import ThanksPage from '@/components/pages/Thanks'
import ErrorPage from '@/components/pages/Error'
import FormPage from '@/components/pages/Form'
import BaseSpinner from '@/components/BaseSpinner'

export default {
  components: {
    ThanksPage,
    ErrorPage,
    FormPage,
    BaseSpinner
  },
  computed: {
    formTemplate() {
      return this.$store.getters.formTemplate
    },
    formSubmitted() {
      return this.$store.getters.submissionState === 'submitted'
    },
    formNotFound() {
      return this.$store.getters.submissionState === 'not_found'
    }
  },
  created() {
    if (!this.formSubmitted) {
      const uri = window.location.search.substring(1);
      const params = new URLSearchParams(uri);
      this.$store.dispatch('getFormSubmission', { id: parseInt(params.get('id')) });
    }
  }
}
</script>

<style lang="scss" module>
.base {
  max-width: 500px;
  margin: 0 auto;
  padding: $spacing;
}
</style>
